/**
 * Nado deployment constants: prod endpoints and on-chain contract addresses.
 *
 * @see {@link https://docs.nado.xyz/developer-resources/api/endpoints | Nado API endpoints}
 * @see {@link https://docs.nado.xyz/more/contracts | Nado contract addresses}
 */

import { getAddress } from 'viem'
import { ink } from 'viem/chains'

/** Nado settles exclusively on Ink. */
export const INK_CHAIN_ID = ink.id
export const NADO_GATEWAY_URL = 'https://gateway.prod.nado.xyz/v1'

/**
 * Nado's Endpoint contract on Ink. Never called by this flow — it's the
 * EIP-712 domain `verifyingContract` both we and Nado's gateway hash
 * signatures over (orders verify against the product address instead).
 */
export const NADO_EIP712_VERIFYING_CONTRACT_ADDRESS = getAddress(
  '0x05ec92D78ED421f3D3Ada77FFdE167106565974E',
)

/**
 * Attribution-only action type — generates no on-chain action. It only splits
 * the withdrawal UDA off from the deposit UDA so backend can tell them apart.
 * Restricted to Nado customer keys by the api-server validator.
 */
export const NADO_WITHDRAWAL_ACTION_TYPE = 'NADO_WITHDRAWAL'
